/**
 * This is a subset of enum `Placements`
 */ var ComboboxPlacements = /*#__PURE__*/ function(ComboboxPlacements) {
    ComboboxPlacements["BottomStart"] = "bottom-start";
    ComboboxPlacements["TopStart"] = "top-start";
    return ComboboxPlacements;
}({});

export { ComboboxPlacements };
//# sourceMappingURL=combobox.js.map
